t = require('views/internal/teacup-with-helpers')('board_archive')

module.exports = ->
  t.div '.archive-controls', ->

    t.div '.archive-controls-search', ->
      t.input '.js-search.js-autofocus', { type: 'text', placeholder: t.l('search archive') }

    t.a '.archive-controls-switch.quiet-button.js-switch-section', { href: '#' }

  t.div '.spinner.loading.js-loading-spinner'

  t.div '.archive-content.js-archive-content'



// WEBPACK FOOTER //
// ./app/scripts/views/templates/board_archive.coffee